// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__AcUKe {
  background: var(--bg);
  color: #fff;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Sidebar_brand__ZdI\\+x {
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}

.Sidebar_groupTitle__6JsBC {
  font-size: 12px;
  opacity: 0.7;
  text-transform: uppercase;
  margin: 16px 8px 6px;
}

.Sidebar_link__gqhPe {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  opacity: 0.92;
}
.Sidebar_link__gqhPe:hover {
  background: rgba(255, 255, 255, 0.12);
  opacity: 1;
}

.Sidebar_active__A874g {
  background: rgba(255, 255, 255, 0.16);
  opacity: 1;
}

.Sidebar_separator__r3DXb {
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
  margin: 8px 0;
}

.Sidebar_footer__VZiHf {
  margin-top: auto;
  font-size: 12px;
  opacity: 0.7;
  padding: 8px;
  border-radius: 8px;
}

@media (max-width: 800px) {
  .Sidebar_sidebar__AcUKe {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    padding: 12px;
  }
  .Sidebar_brand__ZdI\\+x {
    flex-basis: 100%;
    margin-bottom: 0;
  }
  .Sidebar_groupTitle__6JsBC, .Sidebar_separator__r3DXb, .Sidebar_footer__VZiHf {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/layout/Sidebar.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AACF;AACE;EACE,qCAAA;EACA,UAAA;AACJ;;AAGA;EACE,qCAAA;EACA,UAAA;AAAF;;AAGA;EACE,WAAA;EACA,qCAAA;EACA,aAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE;IAAW,mBAAA;IAAqB,eAAA;IAAiB,mBAAA;IAAqB,aAAA;EAItE;EAHA;IAAS,gBAAA;IAAkB,gBAAA;EAO3B;EANA;IAAmC,aAAA;EASnC;AACF","sourcesContent":[".sidebar {\n  background: var(--bg);\n  color: #fff;\n  padding: 20px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.brand {\n  font-weight: 800;\n  margin-bottom: 12px;\n  letter-spacing: .3px;\n}\n\n.groupTitle {\n  font-size: 12px;\n  opacity: .7;\n  text-transform: uppercase;\n  margin: 16px 8px 6px;\n}\n\n.link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  opacity: .92;\n\n  &:hover {\n    background: rgba(255,255,255,.12);\n    opacity: 1;\n  }\n}\n\n.active {\n  background: rgba(255,255,255,.16);\n  opacity: 1;\n}\n\n.separator {\n  height: 1px;\n  background: rgba(255,255,255,.15);\n  margin: 8px 0;\n}\n\n.footer {\n  margin-top: auto;\n  font-size: 12px;\n  opacity: .7;\n  padding: 8px;\n  border-radius: 8px;\n}\n\n@media (max-width: 800px) {\n  .sidebar { flex-direction: row; flex-wrap: wrap; align-items: center; padding: 12px; }\n  .brand { flex-basis: 100%; margin-bottom: 0; }\n  .groupTitle, .separator, .footer { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__AcUKe`,
	"brand": `Sidebar_brand__ZdI+x`,
	"groupTitle": `Sidebar_groupTitle__6JsBC`,
	"link": `Sidebar_link__gqhPe`,
	"active": `Sidebar_active__A874g`,
	"separator": `Sidebar_separator__r3DXb`,
	"footer": `Sidebar_footer__VZiHf`
};
export default ___CSS_LOADER_EXPORT___;
